import { useEffect, useState } from "react"
import AnPopup from "../../../cta_utils/AnPopup"
import { fetchProspectKeywords } from "../api";
import ConditionalRender from "../../../../ConditionalRender";
import { LoaderComponent } from "../../../utils/LoaderComponent";

export const KeywordsPopup = ({
    handleOnClosePopup,
    prospect_id,
    ...props
}) => {
    const [popupData, setPopupData] = useState({
        keywords: [],
        isLoading: false
    })
    useEffect(() => {
        fetchData();
    }, [])
    const fetchData = () => {
        setPopupData({...popupData, isLoading: true})
        fetchProspectKeywords({id: prospect_id}).then(res => {
            setPopupData({keywords: res.data.keywords, isLoading: false})
        }).catch(err => {
            setPopupData({...popupData, isLoading: false})
        })
    }
    return (
        <AnPopup name="KeywordsPopup" handleOnClosePopup={handleOnClosePopup} customStyle={{maxWidth: '420px'}}>
        <div className="text_title">
            Active keywords 
        </div>
        <div  className="line_seperator_ex_light_grey"  style={{ margin: "16px auto" }}></div>
       <ConditionalRender if={popupData.keywords?.length > 0 && !popupData.isLoading}>
        <div className="keywords_container">
            {popupData.keywords.map((keyword) => {
                return (
                    <div className="text_subtitle_big" style={{fontWeight: 500}}>
                        {keyword}
                    </div>
                )
            })}
        </div>
        </ConditionalRender>
        <ConditionalRender if={popupData.isLoading}>
            <LoaderComponent isLoading={popupData.isLoading} ></LoaderComponent>        
        </ConditionalRender>
        </AnPopup>
    )
}